// extracted by mini-css-extract-plugin
export default {"textElementBox":"Board_textElementBox__IQ2-U"};